<template>
  <div class="add">
    <div class="addHead el-row--flex">
      <el-button size="mini" @click="add">
        <i class="el-icon-plus"></i>
        创建合同
      </el-button>
       <el-button size="small"  @click="exportExp">导出</el-button>
    </div>
    <el-form :inline="true" size="mini" :model="filter" class="demo-form-inline">
      <el-form-item label="签署甲方">
        <el-input v-model="filter.signFirstName"></el-input>
      </el-form-item>
      <el-form-item label="签署乙方">
        <el-input v-model="filter.signSecondName"></el-input>
      </el-form-item>
      <el-form-item label="合同状态">
            <el-select v-model="filter.signStatus">
                <el-option label="未签署" value="0,1,2"></el-option>
                <el-option label="签署中" value="3"></el-option>
                <el-option label="已签署" value="4,5"></el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="时间">
              <el-date-picker v-model="filter.createTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      height="718"
      size="mini"
      :border="true">
      <el-table-column
        label="序号"
        type="index"
        min-width="64">
      </el-table-column>
      <el-table-column
        label="文件">
        <template slot-scope="scope">
          <span @click="openWin(scope.row.contractUrl)" style="color: #1875f0;">预览</span>
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="合同状态">
        <template slot-scope="scope">
          {{ $global.signStatusStr(scope.row.signStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        width="140px"
        label="合同标题">
        <template slot-scope="scope">
          {{ scope.row.contractTitle }}
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        label="合同编号">
        <template slot-scope="scope">
          {{ scope.row.contractNum }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="200"
        label="签署甲方">
        <template slot-scope="scope">
          {{ scope.row.signFirstName }}
        </template>
      </el-table-column>
      <el-table-column
        width="200px"
        label="签署乙方">
        <template slot-scope="scope">
          {{ scope.row.signSecondName }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="合同签订日期">
        <template slot-scope="scope">
          {{ scope.row.contractDate }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="200"
        label="甲方证件号">
        <template slot-scope="scope">
          {{ scope.row.firstCertifyNum }}
        </template>
      </el-table-column>
      <el-table-column
        width="200px"
        label="乙方证件号">
        <template slot-scope="scope">
          {{ scope.row.secondCertifyNum }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="甲方签署时间">
        <template slot-scope="scope">
          {{ scope.row.signFirstSigntime }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="乙方签署时间">
        <template slot-scope="scope">
          {{ scope.row.signSecondSigntime }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="280px"
        label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.signFirstUrl !=null&& scope.row.signFirstSigntime==null" type="primary" size="mini" @click="edit(scope.row,1)" >甲方合同地址</el-button> 
          <el-button v-if="scope.row.signSecondUrl !=null && scope.row.signSecondSigntime ==null" type="primary" size="mini" @click="edit(scope.row,2)" >乙方合同地址</el-button> 
          <el-button v-if="scope.row.signOrderBy.substr(0, 1) == '0'" type="primary" :disabled="scope.row.countSecond1 != 0" size="mini" @click="msg(scope.row.contractId, 1)">甲方短信{{ scope.row.countSecond1 == 0 ? '' : `(${scope.row.countSecond1})` }}</el-button>
          <el-button v-if="scope.row.signOrderBy.substr(1, 1) == '0'" type="primary" :disabled="scope.row.countSecond2 != 0" size="mini" @click="msg(scope.row.contractId, 2)">乙方短信{{ scope.row.countSecond2 == 0 ? '' : `(${scope.row.countSecond2})` }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableDataLength"
      @current-change="pageChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <el-dialog
      title="创建合同"
      :visible.sync="addShow"
      width="900px"
      :before-close="addClose">
      <el-form :model="addParam" size="mini" :rules="addRule" ref="add" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同标题">
              <el-input v-model="addParam.contractTitle" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="合同上传">
          <el-upload
            class="upload-demo"
            drag
            :on-change="uploadChange"
            :on-success="upload"
            :data="{
              imgType: 'contract'
            }"
            name="img"
            accept=".pdf"
            action="/sywl/api/uploadImg">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">请上传PDF文件，大小不超过10MB</div>
          </el-upload>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签署甲方" prop="signFirstId">
              <el-select
                v-model="addParam.signFirstId"
                filterable
                remote
                placeholder="请查询签署甲方"
                @change="firstChange"
                :remote-method="searchFirst"
                :loading="searchloading">
                <el-option
                  v-for="item in firstList"
                  :key="item.contractUserId"
                  :label="item.userName"
                  :value="item.contractUserId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签署乙方" prop="signSecondId">
              <el-select
                v-model="addParam.signSecondId"
                filterable
                remote
                placeholder="请查询签署乙方"
                @change="secondChange"
                :remote-method="searchSecond"
                :loading="searchloading">
                <el-option
                  v-for="item in secondList"
                  :key="item.contractUserId"
                  :label="item.userName"
                  :value="item.contractUserId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生效日期" prop="startDate">
              <el-date-picker
                v-model="addParam.startDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="失效日期" prop="endDate">
              <el-date-picker
                v-model="addParam.endDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="合同地址"
      :visible.sync="upShow"
      width="900px"
      :before-close="upClose">
      <el-form :model="upParam" size="mini" :rules="addRule" ref="add" label-width="200px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="合同链接">
              <el-input v-model="upParam.signUrl" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upShow = false">取 消</el-button>
        <!-- <el-button type="primary" @click="save">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
  
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    data() {
      return {
        addShow: false,
        upShow:false,
        searchloading: false,
        firstList: [],
        signStatusList: ['0', '1', '2', '3', '4', '5'],
        secondList: [],
        addParam: {
          contractTitle: '',
          signFirstId: '',
          signFirstName: '',
          signSecondId: '',
          signSecondName: '',
          startDate: '',
          endDate: '',
          contractUrl: ''
        },
         upParam: {        
          signUrl: ''
        },
        addRule: {
          signFirstId: [
            { required: true, message: '签署甲方不能为空', trigger: 'change' }
          ],
          signSecondId: [
            { required: true, message: '签署乙方不能为空', trigger: 'change' }
          ],
          startDate: [
            { required: true, message: '生效日期不能为空', trigger: 'change' },
          ],
          endDate: [
            { required: true, message: '失效日期不能为空', trigger: 'change' }
          ]
        },
        currentPage: 1,
        pageSize: 10,
        filter: {
          signFirstName: '',
           createTime: ''
        },
        tableData: [],
        tableDataLength: 0,
        countArr: []
      }
    },
    mounted() {
      this.refresh();
    },
    methods: {
      add() {
        this.addShow = true;
      },
      addClose() {
        this.addShow = false;
      },
       edit(row,type) {
            this.upShow = true;
            if(type==1){
              this.upParam.signUrl = row.signFirstUrl;
            }else{
              this.upParam.signUrl = row.signSecondUrl;
            }
        },
       upClose() {
        this.upShow = false;
      },
      save() {
        this.$refs['add'].validate(valid => {
          if (valid) {
            if (this.addParam.contractUrl == '') {
              this.$message.error('合同文件还未上传');
            } else {
              let data = new Object();
              for (let key in this.addParam) {
                if (key.indexOf('Date') !== -1) {
                  data[key] = this.$global.format(this.addParam[key], 'yyyy-MM-dd');
                } else {
                  data[key] = this.addParam[key];
                }
              }
              data.contractType = 1;
              this.$global.axios.post(this, '/sywl/api/eqb/contractInfo/add', {
                jsonStr: JSON.stringify(data)
              }, res1 => {
                this.$global.goPay(this, res1.data, res => {
                  this.$message.success('添加成功');
                  location.reload();
                })
              })
            }
          }
        })
      },
     
      upload(res) {
        if (res.errorCode == 0 || res.errorCode == 200) {
          this.addParam.contractUrl = res.resultData.imgUrl;
        }
      },
      uploadChange(res) {
        this.$global.uploadValid(this, res);
      },
      searchFirst(keyword) {
        this.searchId(keyword, 'first');
      },
      searchSecond(keyword) {
        this.searchId(keyword, 'second');
      },
      searchId(keyword, type) {
        this.searchloading = true;
        this.$global.axios.post(this, '/sywl/api/contractUser/getContractUserList', {
          keyword: keyword
        }, res => {
          this.searchloading = false;
          this[type+'List'] = res.data;
        })
      },
      firstChange(e) {
        this.firstList.forEach(ele => {
          if (ele.contractUserId == e) {
            this.addParam.signFirstName = ele.userName;
          }
        })
      },
      secondChange(e) {
        this.secondList.forEach(ele => {
          if (ele.contractUserId == e) {
            this.addParam.signSecondName = ele.userName;
          }
        })
      },
      refresh() {
        let data = this.filter;
        data.pageNo = this.currentPage;
        data.pageSize = this.pageSize;
        data.contractType = 1;
        data.beginTime=(this.filter.createTime===''||this.filter.createTime===null)?null: this.$global.format(this.filter.createTime[0], 'yyyy-MM-dd');
        data.endTime=(this.filter.createTime===''||this.filter.createTime===null)?null:this.$global.format(this.filter.createTime[1], 'yyyy-MM-dd');
        this.$global.axios.post(this, '/sywl/api/contractInfo/list', data, res => {
          res.data.records.forEach(ele => {
            ele.countSecond1 = 0;
            ele.countSecond2 = 0;
          })
          this.tableData = res.data.records;
          this.tableDataLength = Number(res.data.total)
        })
      },
      pageChange(t) {
        this.currentPage = t;
        this.refresh();
      },
     handleSizeChange(n) {
        this.pageSize= n;
        this.refresh();
      },
      onSubmit() {
        this.currentPage = 1;
        this.refresh();
      },
      msg(id, type) {
        this.$global.axios.post(this, '/sywl/api/eqb/contractInfo/sendMess', {
          contractId: id,
          signSquare: type
        }, res => {
          this.$message.success('发送成功');
        }, res => {}, res => {
          let tableIndex;
          this.tableData.forEach((ele, index) => {
            if (id == ele.contractId) {
              tableIndex = index;
            }
          })
          const ind = this.countArr.length;
          this.tableData[tableIndex]['countSecond'+type] = 60;
          const that = this;
          this.countArr[ind] = setInterval(() => {
            that.tableData[tableIndex]['countSecond'+type]--;
            if (that.tableData[tableIndex]['countSecond'+type] == 0) clearInterval(that.countArr[ind]);
          }, 1000)
        })
      },
      openWin(url) {
        window.open(url, null, 'width=1200px,height=700px,scrollbars=yes');
      },
      exportExp() {
        this.$global.axios.post(this, '/sywl/api/contractInfo/allList', {
            signFirstName: this.filter.signFirstName,
            signSecondName: this.filter.signSecondName,
            signStatus: this.filter.signStatus,
            beginTime:(this.filter.createTime===''||this.filter.createTime===null)?null: this.$global.format(this.filter.createTime[0], 'yyyy-MM-dd'),
            endTime:(this.filter.createTime===''||this.filter.createTime===null)?null:this.$global.format(this.filter.createTime[1], 'yyyy-MM-dd'),
            contractType : 1
        }, res => {
          let headName = [
            [
              '合同标题',
              '签署甲方',
              '签署乙方',
              '状态',
              '甲方证件号',
              '甲方签署时间',
              '乙方证件号',
              '乙方签署时间',
              '合同签订日期',
              '创建时间'
            ]
          ];
          res.data.forEach(ele => {
            headName.push([
               ele.contractTitle,
              ele.signFirstName,
              ele.signSecondName,
              this.$global.signStatusStr(ele.signStatus),
              ele.firstCertifyNum,
              ele.signFirstSigntime,
              ele.secondCertifyNum,
              ele.signSecondSigntime,
              ele.contractDate,
              ele.createTime
            ]);
          })
          const worksheet = XLSX.utils.aoa_to_sheet(headName);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, '合同明细.xlsx');
        })
      }
    
    }
  }
</script>

<style lang="scss" scoped>
  .add {
    padding: 12px 16px;
    background-color: #fff;

    & /deep/ .el-dialog__header {
      background-color: #000;
      text-align: left;
      color: #fff;

      .el-dialog__title {
        color: #fff;
      }
    }

    & /deep/ .el-dialog__body {
      padding: 20px;

      .el-form {
        text-align: left;

        .el-select {
          width: calc(100% - 13px);
        }

        .el-date-editor--date {
          display: inline-block;
          width: calc(100% - 13px);
        }
      }
    }

    &Head {
      .el-button {
        margin-bottom: 20px;
        border-color: #1875f0;
        color: #1875f0;
      }
    }

    .el-form {
      text-align: left;
    }

    & /deep/ .el-table {
      .el-table__cell {
        font-size: 12px;
        text-align: center;
      }
    }

    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/add.vue